<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
            @enterChange="inputSearch"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
          <TextModal ref="modal"></TextModal>
        </div>
        <TableToolsWrap
          needLeft
          needRight
          :dataValue="dataValue"
          :value="tableValue"
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="handlerChange"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <Sort v-if="isShowSort" @cancelVisible='cancelVisible' :tableValue='tableValue' @updateList='updateList'></Sort>
    <AddModal ref="addModal" @update="initTableValue"></AddModal>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
import TextModal from '../../components/AModal/textModal/textModal'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import Sort from './components/sort'
import AddModal from './components/addModal.vue'
import AModal from '../../components/AModal'

import {
  getEnterpriseInfo,
  deleteEnterpriseInfo
} from '@/api/superViseInfos.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      tableValue: [],
      utilsBtnList: [
        { name: '新增', cb: 'addEnterprise' },
        { name: '删除', cb: 'batchDelete' },
        { name: '排序', cb: 'sort' }
      ],
      customOtherOpt: {
        pagination: {
          pageSize: 10
        }
      },
      defaultValue: {},
      params: {},
      dataValue: [],
      isShowSort: false
    }
  },
  components: {
    Table,
    Form,
    AddModal,
    AModal,
    TableToolsWrap,
    TextModal,
    Sort
  },
  mounted() {
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true)
        const { data } = await this.getFilterInfos()
        this.dataValue = [data.enpCount, data.patentAllCount]
        const row = this.handlerDateFormat(data.competitorLibraryManages)
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.tableValue = row
        this.tableValue.forEach((item,index)=>{
          item.sortIndex = index + 1
        })
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, '请求出错')
      } finally {
        this.loadingTable(false)
      }
    },
    getFilterInfos() {
      const { pagination } = this.$refs.table
      const { pageSize, pageNum } = pagination
      const params = { ...this.params, ...this.searchParam, pageSize, pageNum }
      return getEnterpriseInfo(params)
    },
    // 批量删除
    async batchDelete() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map((item) => item.id)
      if (id.length === 0) return
      const selectId = id.join(',')
      const { code, msg } = await deleteEnterpriseInfo(selectId)
      this.$apiStatusHandler(code, msg)
      this.initTableValue()
    },
    // 单个删除
    async delete(row) {
      this.customModalOpt.contentTips = '是否确定删除该企业信息'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteEnterpriseInfo(ids)
        this.$apiStatusHandler(code, msg)
        this.initTableValue()
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 表格change
    async handlerChange() {
      // const page = {
      //   pageNum: params[0].current,
      //   pageSize: params[0].pageSize
      // }
      // console.log(page)
      // this.initTableValue(page);
    },
    // 新增企业
    addEnterprise() {
      this.$refs.addModal.handlerVisible(true)
    },
    sort() {
      this.isShowSort = true
    },
    handlerActionClick(val) {
      const {cb, row} = val
      if(this[cb]) {
        this[cb](row)
      }
    },
    cancelVisible() {
      this.isShowSort = false
    },
    updateList() {
      this.initTableValue()
      this.isShowSort = false
    },
    inputSearch(){
      this.toSearch()
    }
  }
}
</script>
